import React from 'react';
import {
  Button,
  Message,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Table,
} from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { parseISO } from 'date-fns';
import { isEmpty } from 'lodash';
import {
  setLogModalShown,
  setLogPage,
} from 'state/restoreDeletedBusiness/actions';
import { logSelector } from 'state/restoreDeletedBusiness/selectors';
import { formatLocalDateTime } from 'utils/dateTimeUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import DefaultPagination from 'components/DefaultPagination';

function LogModal() {
  const dispatch = useDispatch();
  const {
    shown,
    data,
    paging: { page, size, total },
    isLoading,
    errors,
  } = useSelector(logSelector);

  const onPageChange = newPage => dispatch(setLogPage(newPage));
  const onClose = () => dispatch(setLogModalShown(false));

  return (
    <Modal open={shown} onClose={onClose}>
      <ModalHeader>Restore Deleted Business Logs</ModalHeader>
      <ModalContent>
        <Message negative hidden={isEmpty(errors)}>
          <Message.Header>Error</Message.Header>
          <ul>
            {errors.map(e => (
              <li key={e}>{e}</li>
            ))}
          </ul>
        </Message>
        <Table celled selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time</Table.HeaderCell>
              <Table.HeaderCell>Performed By</Table.HeaderCell>
              <Table.HeaderCell>Business ID</Table.HeaderCell>
              <Table.HeaderCell>Reason</Table.HeaderCell>
              <Table.HeaderCell>Notes</Table.HeaderCell>
              <Table.HeaderCell>SF Ticket Number</Table.HeaderCell>
              <Table.HeaderCell>Ticket Created At</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {isLoading ? (
              <Table.Row>
                <Table.Cell colSpan={7}>
                  <LoadingSpinner />
                </Table.Cell>
              </Table.Row>
            ) : (
              data.map(log => {
                const ticket = log.deletion_ticket || {};
                const ticketCreatedAt = ticket.created_at
                  ? formatLocalDateTime(parseISO(ticket.created_at))
                  : '-';
                const logTime = log.time
                  ? formatLocalDateTime(parseISO(log.time))
                  : '-';
                return (
                  <Table.Row key={log.id}>
                    <Table.Cell>{logTime}</Table.Cell>
                    <Table.Cell>{log.performed_by || '-'}</Table.Cell>
                    <Table.Cell>{log.business_id || '-'}</Table.Cell>
                    <Table.Cell>{ticket.reason || '-'}</Table.Cell>
                    <Table.Cell>{ticket.notes || '-'}</Table.Cell>
                    <Table.Cell>{ticket.sf_ticket_number || '-'}</Table.Cell>
                    <Table.Cell>{ticketCreatedAt}</Table.Cell>
                  </Table.Row>
                );
              })
            )}
          </Table.Body>
        </Table>
        {!isLoading && (
          <DefaultPagination
            totalCount={total}
            activePage={page}
            pageSize={size}
            onPageChangeV2={onPageChange}
          />
        )}
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>Close</Button>
      </ModalActions>
    </Modal>
  );
}

export default LogModal;
